var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReportActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.262,
    height: 20,
    viewBox: "0 0 19.262 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.027,
    x2: 1,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5fa2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_261",
    "data-name": "Subtraction 261",
    d: "M17644.693,8954h-14.131a2.56,2.56,0,0,1-2.561-2.554v-14.888a2.563,2.563,0,0,1,2.561-2.559h14.131a2.583,2.583,0,0,1,2.57,2.559v14.888A2.577,2.577,0,0,1,17644.693,8954Zm-11.719-5.219a.7.7,0,1,0,0,1.4h9.309a.7.7,0,0,0,0-1.4Zm0-3.726a.7.7,0,0,0,0,1.4h6.514a.7.7,0,0,0,0-1.4Zm3.725-6.509a.691.691,0,0,0-.494.206l-2.793,2.79a.691.691,0,0,0-.152.758.706.706,0,0,0,.65.433.671.671,0,0,0,.484-.2l2.3-2.3,1.377,1.372a.659.659,0,0,0,.467.2l.045,0a.7.7,0,0,0,.5-.24l2.8-3.258a.7.7,0,1,0-1.068-.909l-2.3,2.682-1.318-1.324A.714.714,0,0,0,17636.7,8938.545Z",
    transform: "translate(-17628.002 -8933.998)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportActive);
export default __webpack_public_path__ + "static/media/icon-report-active.c8f48b42e62cbbf6cd9fb45d78036ffb.svg";
export { ForwardRef as ReactComponent };